import { APIRequest } from '@reverbdotcom/discovery-ui';

const wishlistListingDataAttr = 'wishlist-toggle-listing';
const wishlistToggleButtons = `[data-${wishlistListingDataAttr}]`;
const addToWishlistSelector = '[data-bind="add-to-wishlist"]';
const removeFromWishlistSelector = '[data-bind="remove-from-wishlist"]';
const response = '[data-bind="wishlist-response"]';

const apiEndpoint = '/api/my/wishlist/';

function bindWishListButtonClick() {
  $(document).on('click', addToWishlistSelector, handleAddToWishlistClick);
  $(document).on('click', removeFromWishlistSelector, handleRemoveFromWishlistClick);
}

function handleAddToWishlistClick(e) {
  e.preventDefault();
  addToWishlistButtonClicked(listingIdFromClick(e));
}

function handleRemoveFromWishlistClick(e) {
  e.preventDefault();
  removeFromWishlistButtonClicked(listingIdFromClick(e));
}

function listingIdFromClick(clickEvent) {
  const button = $(clickEvent.target).closest(wishlistToggleButtons);
  return button.data(wishlistListingDataAttr);
}

function removeFromWishlistButton(listingId) {
  return $(wishlistToggleButtonsSelectorForListing(listingId) + removeFromWishlistSelector);
}

function addToWishlistButton(listingId) {
  return $(wishlistToggleButtonsSelectorForListing(listingId) + addToWishlistSelector);
}

function wishlistToggleButtonsSelectorForListing(listingId) {
  return `[data-${wishlistListingDataAttr}="${listingId}"]`;
}

function addToWishlistButtonClicked(listingId) {
  addToWishlist(listingId)
    .done(() => {
      addToWishlistButton(listingId).addClass('hide');
      removeFromWishlistButton(listingId).removeClass('hide');
      $(response).stop()
        .show()
        .delay(3500)
        .hide('fast');
    });
}

function removeFromWishlistButtonClicked(listingId) {
  removeFromWishlist(listingId)
    .done(() => {
      removeFromWishlistButton(listingId).addClass('hide');
      addToWishlistButton(listingId).removeClass('hide');
    });
}

function addToWishlist(listingId) {
  return ajaxRequest(listingId, 'put');
}

function removeFromWishlist(listingId) {
  return ajaxRequest(listingId, 'destroy');
}

function apiEndpointForListing(listingId) {
  return apiEndpoint + listingId;
}

function ajaxRequest(listingId, httpMethod) {
  const url = apiEndpointForListing(listingId);
  return APIRequest[httpMethod](url);
}

export default {
  init: bindWishListButtonClick,
};



// WEBPACK FOOTER //
// ./javascripts/components/legacy/wish_list.js